'use strict';
{
    var app = angular.module('tf.portfolio.widgets.icConcession', [])
        .controller('icConcessionChartCtrl', ['$scope', '$filter', '$localStorage', '$timeout', function icChartController($scope, $filter, $localStorage, $timeout) {
            function barColour(percent) {
                percent = Math.min(percent, 1);
                return "hsl(" + Math.round(120 * (percent)) + ", 70%, 45%)";
            }


            $scope.widgetContentHeight = 250;

            $scope.$on('gridster-resized', function() {
                $scope.updateChartHeight();
            });


            $scope.$watch('gridsterItem.sizeY', function() {
                $scope.updateChartHeight();
            });

            $scope.updateChartHeight = function() {
                $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
                $scope.interCommOptions.chart.height = $scope.widgetContentHeight;
                if ($scope.chartApi) {
                    $scope.chartApi.refresh();
                }
            };

            $scope.interCommOptions = {
                chart: {
                    type: 'scatterChart',
                    height: $scope.widgetContentHeight,
                    margin : {
                        top: 50,
                        right: 80,
                        bottom: 50,
                        left: 60
                    },
                    x: function(d){return d.x;},
                    y: function(d){return d.y;},
                    pointSize: function(d){return d.size;},
                    showDistX: true,
                    padData: false,
                    clipEdge: false,
                    showDistY: true,
                    showControls: false,
                    showValues: true,
                    transitionDuration: 1000,
                    stacked: true,
                    useInteractiveGuideline: true,
                    xAxis: {
                        tickFormat: d3.format('.03f'),
                        axisLabel: 'Composite (2 Day Look-Ahead) Delta',
                        highlightZero: true,
                        ticks: 10

                    },
                    yAxis: {
                        axisLabel: 'Inter-commodity Concession Value',
                        tickFormat: d3.format('s'),
                        highlightZero: true,
                        showMaxMin: false,
                        ticks: 10
                    },
                    pointScale: d3.scale.linear(),
                    pointRange: [160, 10000],
                    tooltip : {
                        contentGenerator : function(e) {
                            var key = e.series[e.pointIndex].key;
                            return '<h3>' + key + '</h3>' +
                                "<table><tbody>" +
                                "<tr><td class=\"key\">Current</td> <td class=\"value\">" + e.point.x.toFixed(4) + "</td></tr>" +
                                "<tr><td class=\"key\">WFPR</td> <td class=\"value\">" + e.point.size.toFixed(2) + "</td></tr>" +
                                "<tr><td class=\"key\">Concession</td> <td class=\"value\">$" + e.point.y.toFixed(2) + "</td></tr>" +
                                "</tbody></table>";
                        }
                    }
                }

            };

            $scope.icConcessionBySecurity = [];
            $scope.interCommData = [];
            $scope.deltaUtilization = [];
            $scope.deltaUtilisedOpen = true;
            $scope.spreadRatings = [];

            $scope.$on('margin.whatif.changed', function updateData(event, whatIfMargin) {
                var interCommData = [];
                var spreadRatings = [];
                var icConcessionBySecurity = [];

                for (var i = 0; i < whatIfMargin.interCommoditySpreads.length; i++) {

                    var spread = whatIfMargin.interCommoditySpreads[i];
                    spread.legs.sort(function(a, b) {
                        if (a < b)
                            return -1;
                        if (a > b)
                            return 1;
                    });

                    spreadRatings.push({
                        multiSpread : spread.legs.length > 2,
                        singleSpread : spread.legs.length <= 2,
                        legs : '(' + spread.legs.join(', ') + ')',
                        rate : spread.rate * 100,
                        offset : spread.offset
                    })
                }

                $scope.spreadRatings = spreadRatings;

                var deltaUtilisation = [];

                for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                    var cc = whatIfMargin.combinedCommodities[i];

                    if (cc.icConcession != 0) {
                        icConcessionBySecurity.push({value: cc.icConcession, label: cc.security});
                    }

                    interCommData.push({key : cc.security, values : [{x: cc.spanDelta, y: cc.icConcession, size : cc.wfpr}]});

                    var percentUsed = 0;
                    if (cc.spanDelta != 0) {
                        percentUsed = cc.spanDelta != 0 ?(cc.spanDeltaUsed / cc.spanDelta * 100) : 0;
                    }
                    deltaUtilisation.push(
                        {security : cc.security,
                            total : cc.spanDelta,
                            used : cc.spanDeltaUsed,
                            remaining : cc.spanDelta - cc.spanDeltaUsed,
                            level : barColour(percentUsed / 100),
                            percentUtilised : percentUsed});
                }

                deltaUtilisation.sort(function (a, b) {
                    if (a.percentUtilised < b.percentUtilised)
                        return -1;
                    if (a.percentUtilised > b.percentUtilised)
                        return 1;

                    if (a.security < b.security)
                        return -1;
                    if (a.security > b.security)
                        return 1;

                    return 0;
                });

                $scope.icConcessionBySecurity = icConcessionBySecurity;
                $scope.deltaUtilization = deltaUtilisation;


                interCommData.sort(function (a, b) {
                    if (a.key < b.key) {
                        return -1;
                    }

                    if (a.key > b.key) {
                        return 1;
                    }

                    return 0;
                });

                $timeout(function () {
                    $scope.showChart(interCommData);
                }, 200);

            });

            $scope.showChart = function(chart) {
                $scope.activeChart = chart;

                $scope.interCommData.length = 0;

                chart.forEach(function (d) {
                    $scope.interCommData.push(d);
                });

                if ($scope.chartApi) {
                    $scope.chartApi.update();
                }
            }

        }]);
}
